import DateTimeUtils from '../common/utils/DateTimeUtils';

export default function ScheduleFieldValueOverrideRenderer(overriddenByUser, overriddenTime, locale) {
  return (
    <div style={{ textAlign: 'left' }}>
      This value was recently modified by <strong>{overriddenByUser}</strong> at <strong>{DateTimeUtils.formatFullShortDateTime(overriddenTime, locale)}</strong>.
    </div>
  );
}